import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export enum ToastTypes {
	SUCCESS = 'success',
	ERROR = 'error',
	WARN = 'warn',
	INFO = 'info',
}

function Toast({ title, type = ToastTypes.WARN, className }: toastProps) {
	toast[type](title, {
		position: toast.POSITION.TOP_RIGHT,
		className,
	});
}

export interface toastProps {
	title?: string;
	type?: ToastTypes;
	className?: string;
}

export default Toast;
